import http from '../http'

/**
 * 文章相关接口
 */
const articleApi = {
  /**
   * 获取文章列表
   * @param {Object} params - 查询参数 {page, limit, category, keyword}
   * @returns {Promise}
   */
  getList(params) {
    return http.get('/article/list', params)
  },

  /**
   * 获取文章详情
   * @param {String|Number} id - 文章ID
   * @returns {Promise}
   */
  getDetail(id) {
    return http.get(`/article/${id}`)
  },

  /**
   * 创建文章
   * @param {Object} data - 文章数据
   * @returns {Promise}
   */
  create(data) {
    return http.post('/article', data)
  },

  /**
   * 更新文章
   * @param {String|Number} id - 文章ID
   * @param {Object} data - 文章数据
   * @returns {Promise}
   */
  update(id, data) {
    return http.put(`/article/${id}`, data)
  },

  /**
   * 删除文章
   * @param {String|Number} id - 文章ID
   * @returns {Promise}
   */
  delete(id) {
    return http.delete(`/article/${id}`)
  },

  /**
   * 获取文章分类
   * @returns {Promise}
   */
  getCategories() {
    return http.get('/article/categories')
  },

  /**
   * 获取热门文章
   * @param {Number} limit - 获取数量
   * @returns {Promise}
   */
  getHotArticles(limit = 5) {
    return http.get('/article/hot', { limit })
  }
}

export default articleApi 